import type { MilestoneKind } from './data';

// Only the sourced hints: Culture started and Stocking prep have no written definition yet.
export const MILESTONE_HINT: Partial<Record<MilestoneKind, string>> = {
  water_in: 'The first day the water went in. This day is Prep day 1.',
};

export const STOCKING_HINT = 'The day the shrimp are stocked. This day is DOC 1.';

export const TECHNICIAN_PREP_NOTE = 'A Farm Technician marks the pond as stocked. Ask your Farm Technician when it\'s ready.';

export const TECHNICIAN_START_NOTE = 'A Farm Technician starts pre-stocking and stocking. Ask your Farm Technician if this pond should start.';
